import { render, staticRenderFns } from "./AdminShopWithdrawals.vue?vue&type=template&id=ada36e60&"
import script from "./AdminShopWithdrawals.vue?vue&type=script&lang=js&"
export * from "./AdminShopWithdrawals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports